import React from 'react';
import Icon from '../../../../../../../common/components/Icon/Icon';
import FieldFormControl from '../../../../../../../common/components/FieldFormControl/FieldFormControl';
import { Field } from 'redux-form';

class TreeRow extends React.PureComponent {
  state = {
    show: false,
  };

  render() {
    const { fieldName, label, children } = this.props;
    const { show } = this.state;
    return (
      <div>
        <div className="scheme-three-row">
          <div className="icon-container" onClick={this._toggleChildren}>
            {children && <Icon name={`caret-${show ? 'down' : 'right'}`} />}
          </div>
          <Field
            value={true}
            type="checkbox"
            name={fieldName}
            component={FieldFormControl}
            onChange={this._handleToggleSelectAll}
          >
            {label}
          </Field>
        </div>
        {show && <div className="child-container">{children}</div>}
      </div>
    );
  }

  _toggleChildren = () => {
    this.setState({ show: !this.state.show });
  };

  _handleToggleSelectAll = () => {
    this.setState({ show: true });

    // onSelectAll()
  };
}

export default TreeRow;
